import { render, staticRenderFns } from "./producto.vue?vue&type=template&id=3b07b39a&scoped=true&"
import script from "./producto.vue?vue&type=script&lang=js&"
export * from "./producto.vue?vue&type=script&lang=js&"
import style0 from "./producto.vue?vue&type=style&index=0&id=3b07b39a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07b39a",
  null
  
)

export default component.exports